import { render, staticRenderFns } from "./ContentBlocks.vue?vue&type=template&id=6183fb66&scoped=true&"
import script from "./ContentBlocks.vue?vue&type=script&lang=js&"
export * from "./ContentBlocks.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlocks.vue?vue&type=style&index=0&id=6183fb66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6183fb66",
  null
  
)

export default component.exports